export default __webpack_public_path__ + "static/media/shop_logo_white.ea555a59.jpg";